import { readStorageJson, writeStorageJson } from '@runtime/shared/utils/storage'

type Metric = { count: number; lastAt: string; lastTarget: string | null }
const KEY = 'usp_home_tile_clicks_v1'

export function trackHomeTileClick(tileId: string, target: string) {
  const metrics = readStorageJson<Record<string, Metric>>(KEY, {})
  metrics[tileId] = {
    count: (metrics[tileId]?.count || 0) + 1,
    lastAt: new Date().toISOString(),
    lastTarget: target,
  }
  writeStorageJson(KEY, metrics)
  window.dispatchEvent(new CustomEvent('usp:home-tile-click', { detail: { tileId, target } }))
}
